module.exports = __webpack_public_path__ + "img/f1.2fbc6a19.png";